<template>
  <div style="padding: 30px 0">
    <a-row type="flex" justify="space-between" style="margin-bottom:15px">
      <a-col>
        <a-row type="flex" align="middle" :gutter="15">
          <a-col>
            <span style="height:25px;border-left:3px solid #35B5FE;"></span>
          </a-col>
          <a-col>
            <b>软性点评</b>
          </a-col>
        </a-row>
      </a-col>
      <a-col
        v-if="
          isGranted('post_manager.post_process_list.btn_list_audit') &&
            id == $store.state.user.uid
        "
      >
        <a-button type="primary" icon="plus" @click="$emit('addSoft')">软性点评</a-button>
      </a-col>
    </a-row>
    <a-row type="flex">
      <a-col span="24" style="padding:0 20px">
        <a-list itemLayout="vertical">
          <div
            v-if="showSoftLoadingMore"
            slot="loadMore"
            :style="{
              textAlign: 'center',
              marginTop: '12px',
              height: '32px',
              lineHeight: '32px'
            }"
          >
            <a-spin v-if="softLoadingMore" />
            <a-button v-else @click="getSoftList()">加载更多</a-button>
          </div>

          <a-list-item v-for="item in softList" :key="item.id">
            <a-list-item-meta :description="''" :title="resume.name"></a-list-item-meta>
            <p style="padding-top:8px;">
              <b style="margin-right:20px;">极端外貌评价</b>
              <template v-for="extra in item.extra">
                <a-button
                  :key="extra"
                  disabled
                  style="cursor:default;background-color:#e6f1fc;color: #1989fa;margin-left:12px"
                >{{ extra }}</a-button>
              </template>
            </p>
            <div slot="extra" style="min-width:200px;">
              <b style="margin:20px 0 10px;display:block">软性评价</b>
              <template v-for="(soft, index) in item.soft">
                <div :key="index">{{ soft }}</div>
              </template>
            </div>
          </a-list-item>
        </a-list>
      </a-col>
    </a-row>
    <a-divider></a-divider>
    <a-row type="flex" justify="space-between" style="margin-bottom:15px">
      <a-col>
        <a-row type="flex" align="middle" :gutter="15">
          <a-col>
            <span style="height:25px;border-left:3px solid #35B5FE;"></span>
          </a-col>
          <a-col>
            <b>沟通记录</b>
          </a-col>
        </a-row>
      </a-col>
      <a-col>
        <a-button  v-if="
          isGranted('post_manager.post_process_list.btn_list_audit') &&
            id == $store.state.user.uid
        " type="primary" icon="plus" @click="$emit('addCommunication')">文字沟通记录</a-button>
        <a-button v-if="$store.state.status_origin > 2 && $store.state.status_origin < 11" type="primary" icon="plus"  style="margin-left: 10px" @click="$emit('addAttachment')">沟通附件</a-button>
      </a-col>
    </a-row>
    <div v-if='this.communicationList.length !== 0'>
      <div style="padding-left: 18px;color:black;font-size: 16px;margin-top:15px">文字沟通记录：
    </div>
    <a-row type="flex">
      <a-col span="24" style="padding:0 20px">
        <a-list itemLayout="vertical">
          <div
            v-if="showComLoadingMore"
            slot="loadMore"
            :style="{
              textAlign: 'center',
              marginTop: '12px',
              height: '32px',
              lineHeight: '32px'
            }"
          >
            <a-spin v-if="comLoadingMore" />
            <a-button v-else @click="getCommunicationList()">加载更多</a-button>
          </div>

          <a-list-item v-for="item in communicationList" :key="item.id">
            <a-list-item-meta :description="'添加时间：' + item.created_at" title="来自HR的沟通"></a-list-item-meta>
            <p v-html="item.content.replace(/\n/g, '<br>')"></p>
          </a-list-item>
        </a-list>
      </a-col>
    </a-row>
    </div>
   
    <div v-if="firstRecord || offerRecord || zipRecord">
      <div style="padding-left: 18px;color:black;font-size: 16px;">沟通记录附件：
      </div>
      <div style="margin-top:15px" class="btns">
        <div class="first">
          <div v-if="firstData.length !== 0">
            <a-popover trigger="click" placement="bottomLeft" :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}"
          :overlayStyle="{width:'380px',maxHeight:'250px',overflow:'auto'}">
          <div slot="content">
            <a @click="() => downloadAllZip('first',firstData[0].post_interview_id,'一面沟通附件')">打包下载</a>
            <a-table rowKey="id" :columns="columns" :data-source="firstData" :pagination="false" >
            <span slot="action" slot-scope="record">
              <a @click="() => downloadFirst(record.path,record.file_name)">下载</a>
            </span>
          </a-table>
          </div>
          <a-button style="margin-left: 40px;" >
              <a-icon type="link" />一面沟通附件
            </a-button>
         </a-popover>
          </div>
          <div v-if="offerData.length !== 0">
          <a-popover  trigger="click" placement="bottomLeft"
           :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}"
           :overlayStyle="{width:'380px',maxHeight:'250px',overflow:'auto'}">
          <div slot="content">
            <a @click=" () => downloadAllZip('offer',offerData[0].post_offer_id,'offer沟通附件')">打包下载</a>
            <a-table rowKey="id" :columns="columns" :data-source="offerData" :pagination="false">
            <span slot="action" slot-scope="record">
              <a @click="() => downloadOffer(record.path,record.file_name)">下载</a>
            </span>
          </a-table>
          </div>
          <a-button style="margin-left: 20px;">
              <a-icon type="link" />offer沟通附件
          </a-button>
        </a-popover>
        </div>
        </div>
        
        <div  class="popoverList" v-if="zipRecord">
          <div v-for="(item,index) in zipData" :key="item.id" class="popover">
          <a-popover trigger="click" placement="bottomLeft"
           :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}"
            :overlayStyle="{width:'380px',maxHeight:'250px',overflow:'auto'}">
          <div slot="content">
            <a @click="()=>downloadAllZip('zip',zipData[index].attachments[0].zip_id,zipData[index].zip_name)">打包下载</a>
            <a-table rowKey="id" :columns="columns" :data-source="zipData[index].attachments" :pagination="false">
            <span slot="action" slot-scope="record">
              <a @click="() => downloadZip(record.path,record.file_name)">下载</a>
            </span>
          </a-table>
          </div>
          <a-tooltip placement="right" :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}" >
          <template slot="title" v-if="zipData[index].zip_name.length>10">
            <span>{{ zipData[index].zip_name }}</span>
          </template>
          <a-button style="margin-left: 20px;"><a-icon type="link" />{{ zipData[index].zip_name }}</a-button>
         </a-tooltip>
        </a-popover>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@/api";
import { async } from "q";
import baseComponentVue from "@/components/base-component.vue";
export default {
  name: "Contact",
  extends: baseComponentVue,
  props: ["resume", "id"],
  data() {
    return {
      showSoftLoadingMore: false,
      firstRecord: true,
      offerRecord: true,
      zipRecord: true,
      columns: [
          {
            title: '文件名称',
            dataIndex: 'file_name',
            key: 'file_name',
            width: '35%',
            ellipsis: true,
          },
          {
            title: '上传时间',
            dataIndex: 'createdAt',
            width: '35%',
            key: 'createdAt',
            ellipsis: true,
          },
          {
            title: '文件路径',
            dataIndex: 'path',
            key: 'path',
            colSpan:0,
            customRender:()=>{return {attrs:{colSpan:0}}},
            ellipsis: true,
          },
          {
            title: '操作',
            key: 'action',
            width: '10%',
            scopedSlots: { customRender: 'action' },
          }],
      softLoadingMore: false,
      softPage: 0,
      firstData:[],
      offerData: [],
      zipData: [],
      showComLoadingMore: false,
      comLoadingMore: false,
      comPage: 0,
      softList: [],
      communicationList: []
    };
  },
  created() {
    this.getSoftList();
    this.getCommunicationList();
    this.getCommunicationAttachment()
  },
  methods: {
    async getCommunicationList() {
      this.comLoadingMore = true;
      let resume_id = this.resume.id;
      this.comPage = this.comPage + 1;
      let params = {
        page: this.comPage,
        limit: 3,
        resume_id
      };
      let {
        list: communicationList,
        total
      } = await Api.resume.getCommunicationList(params);
      this.comLoadingMore = false;
      this.communicationList = [
        ...this.communicationList,
        ...communicationList
      ];
      this.showComLoadingMore = total > this.comPage * 3 ? true : false;
    },
    async updateCommunication() {
      this.comLoadingMore = true;
      let { list: communicationList } = await Api.resume.getCommunicationList({
        page: 1,
        limit: 1,
        resume_id: this.resume.id
      });
      this.comLoadingMore = false;
      this.communicationList = [
        ...communicationList,
        ...this.communicationList
      ];
    },
    async updateAttachment() {
      let post_id = this.$store.state.post_id;
      console.log(post_id)
      let data= await Api.resume.getCommunicationAttachment({
        post_id: post_id
      })
      console.log(data)
      data.interview.length === 0 ? this.firstRecord = false : this.firstData=data.interview;
      data.offer.length === 0 ? this.offerRecord = false : this.offerData = data.offer;
      this.zipRecord = true 
      this.zipData = data.zip;
    },
    async downloadFirst(url,name) {
      let fileUrl =url;
      console.log(fileUrl)
      let fileName = name;
      //创建一个a标签
      const link = document.createElement('a');
      //设置是否在当前页面打开，target其他取值及含义：_blank：新窗口打开。_parent：在父窗口中打开链接。_self：默认，当前页面跳转。_top：在当前窗体打开链接，并替换当前的整个窗体(框架页)。
      link.target = '_blank'  //如果该值为‘_self'该行可忽略
      //将a标签隐藏起来
      link.style.display = 'none';
        fetch(fileUrl).then(res => res.blob()).then((blob) => {
                  link.href = URL.createObjectURL(blob);
                  link.download = fileName;
                  document.body.appendChild(link);
                  link.click();
                  link.remove();
                });

    },
    async downloadAllZip(type,id,name) {
      if(type === 'first') {
        console.log(id)
        let res = await Api.order.downloadFirstAttachment({post_interview_id:id})
        const blob = new Blob([res], {   //下载重要部分
          type: 'application/zip'   //下载zip，类型可以改变
        })
        let link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.setAttribute('download', name)
        link.click()
        link = null
      } else if(type === 'offer') {
        console.log(id)
        let res = await Api.order.downloadOfferAttachment({post_offer_id:id})
        const blob = new Blob([res], {   //下载重要部分
          type: 'application/zip'   //下载zip，类型可以改变
        })
        let link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.setAttribute('download', name)
        link.click()
        link = null
      } else if (type === 'zip') {
        console.log(id)
        let res = await Api.order.downloadZipAttachment({zip_id:id})
        const blob = new Blob([res], {   //下载重要部分
          type: 'application/zip'   //下载zip，类型可以改变
        })
        let link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.setAttribute('download', name)
        link.click()
        link = null
      }
        
    },
    async downloadZip(url,name) {
      let fileUrl =url;
      console.log(fileUrl)
      let fileName = name;
      //创建一个a标签
      const link = document.createElement('a');
      //设置是否在当前页面打开，target其他取值及含义：_blank：新窗口打开。_parent：在父窗口中打开链接。_self：默认，当前页面跳转。_top：在当前窗体打开链接，并替换当前的整个窗体(框架页)。
      link.target = '_blank'  //如果该值为‘_self'该行可忽略
      //将a标签隐藏起来
      link.style.display = 'none';
        fetch(fileUrl).then(res => res.blob()).then((blob) => {
                  link.href = URL.createObjectURL(blob);
                  link.download = fileName;
                  document.body.appendChild(link);
                  link.click();
                  link.remove();
                });

    },
    async downloadOffer(url,name) {
      let fileUrl =url;
      let fileName = name;
      //创建一个a标签
      const link = document.createElement('a');
      //设置是否在当前页面打开，target其他取值及含义：_blank：新窗口打开。_parent：在父窗口中打开链接。_self：默认，当前页面跳转。_top：在当前窗体打开链接，并替换当前的整个窗体(框架页)。
      link.target = '_blank'  //如果该值为‘_self'该行可忽略
      //将a标签隐藏起来
      link.style.display = 'none';
        fetch(fileUrl).then(res => res.blob()).then((blob) => {
                  link.href = URL.createObjectURL(blob);
                  link.download = fileName;
                  document.body.appendChild(link);
                  link.click();
                  link.remove();
                });
    },
    async getCommunicationAttachment() {
      let post_id = this.$store.state.post_id;
      console.log(post_id)
      let data= await Api.resume.getCommunicationAttachment({
        post_id: post_id
      })
      console.log(data)
      data.interview.length === 0 ? this.firstRecord = false : this.firstData=data.interview;
      data.offer.length === 0 ? this.offerRecord = false : this.offerData = data.offer;
      data.zip.length === 0 ? this.zipRecord = false : this.zipData = data.zip;
    },
    async getSoftList() {
      this.softLoadingMore = true;
      let resume_id = this.resume.id;
      this.softPage = this.softPage + 1;
      let params = {
        page: this.softPage,
        limit: 3,
        resume_id
      };
      let { list: softList, total } = await Api.resume.getSoftSkillList(params);
      this.softLoadingMore = false;

      softList = this.handleSoftList(softList);
      this.softList = [...this.softList, ...softList];
      this.showSoftLoadingMore = total > this.softPage * 3 ? true : false;
    },
    async updateSoft() {
      this.softLoadingMore = true;
      let resume_id = this.resume.id;
      let params = {
        page: 1,
        limit: 1,
        resume_id
      };
      let { list: softList } = await Api.resume.getSoftSkillList(params);
      this.softLoadingMore = false;

      softList = this.handleSoftList(softList);
      this.softList = [...softList, ...this.softList];
    },
    handleSoftList(softList) {
      softList.forEach(soft => {
        soft.extra = soft.extra || [];
        soft.soft = soft.soft || [];
        let arr = soft.tags.split(",");
        arr.forEach(item => {
          item.indexOf(":") == -1
            ? soft.extra.push(item)
            : soft.soft.push(item);
        });
      });
      return softList;
    }
  }
};
</script>
<style lang="scss" scoped>
.btns ::v-deep .ant-btn{
  span {
    display: inline-block;
    overflow: hidden;
    vertical-align: top;
    max-width: 160px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.btns {
  padding-bottom: 240px;
  .first {
    display: flex;
  div {
    width: 320px;
  }
  }
 
}
.popoverList {
  display: flex;
  padding-bottom: 240px;
  flex-wrap: wrap;
  margin-left: 20px;
  .popover {
    margin-top: 20px;
    width: 300px;
  }
  }
</style>
